import { StatusApprovalsEnum } from "../../Enum/status-approvals-enum";
import { WFXRolesEnum } from "../../Enum/wfx-roles.enum";

export class ApprovalsReqDto {
    approvalStatus: StatusApprovalsEnum;
    role: WFXRolesEnum;
    id: number;
    constructor(
        approvalStatus: StatusApprovalsEnum,
        role: WFXRolesEnum,
        id: number,
    ) {
        this.approvalStatus = approvalStatus
        this.role = role
        this.id = id
    }
}
